var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sticky-header-layout',[_c('featured-list-table',{attrs:{"data":_vm.list,"is-loading":_vm.isLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }